<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-12 col-lg">
          <h3 class="card-header-title">Mid-point Check In</h3>
        </div>
        <div class="col-6 col-lg-auto text-lg-right">
          <span class="minor">
            <span class="strong">Open Date:</span>
            {{ placement.mid_point_checkin_open_date | date }}
          </span>
        </div>
        <div class="col-6 col-lg-auto text-lg-right">
          <span class="minor">
            <span class="strong">Due Date:</span>
            {{ placement.mid_point_checkin_due_date | date }}
          </span>
        </div>
      </div><!-- /.row -->
    </div>

    <ul class="list-data no-links no-hover">
      <li>
        <div class="row align-items-center">
          <div class="col">
            <p>Date Completed *</p>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <div class="form-group">
              <input :disabled="!($userIsManager || $userIsCoordinator)" type="date" v-model="date_complete" class="form-control" name="date_complete" v-validate="'required'">
            </div>
          </div>
        </div>
      </li>
      <li>
        <div class="row align-items-center">
          <div class="col mb-2">
            <p>Feedback</p>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-12">
            <textarea
              :disabled="!($userIsManager || $userIsCoordinator)"
              class="form-control"
              v-model="feedback"
              rows="4"
            />
          </div>
        </div>
      </li>
    </ul><!-- /.list-data -->
    <div class="card-footer text-right" v-if="($userIsManager || $userIsCoordinator)" >
      <a href="" @click.prevent="handleSave" class="btn btn-sm btn-success">
        Save Changes
      </a>
    </div>
  </div><!-- /.card -->
</template>

<script>
import { placementComputed, graduateComputed, placementMethods } from 'vx/helpers'
import { helpers } from 'mixins/placements'

export default {
  mixins: [helpers],

  computed: {
    ...placementComputed,
    ...graduateComputed,

    date_complete: {
      get () {
        return this.placementMidPointCheckin.date_complete || ''
      },
      set (value) {
        this.setPlacementProperty({ property: 'mid_point_checkin.date_complete', value })
      }
    },
    feedback: {
      get () {
        return this.placementMidPointCheckin.feedback || ''
      },
      set (value) {
        this.setPlacementProperty({ property: 'mid_point_checkin.feedback', value })
      }
    }
  },

  methods: {
    ...placementMethods,

    async handleSave () {
      let payload = {
        date_complete: this.placement.mid_point_checkin.date_complete,
        feedback: this.placement.mid_point_checkin.feedback
      }

      await this.storeMidPointCheckin({ placement: this.placement.id, graduate: this.placement.graduate_id, payload })

      this.$noty.success('Mid Point Check In Saved')
      this.$router.push({ name: 'graduates.placements.single', params: { placementId: this.placement.id, graduateId: this.placement.graduate_id } })
      this.$validator.reset()
    }
  }
}
</script>

<style>
  .swal-text {
    text-align : center !important;
  }
</style>
